export default "__VITE_ASSET__BXAqZCVM__"